import { useTheme } from '@emotion/react'
import { i18n } from '@lingui/core'

import { useIsMobile } from '@twistopayments/design-system/hooks'
import { CloseIcon } from '@twistopayments/design-system/icons/inline'

import { IconButton } from '../button'

import * as styles from './modal-closer.styles'

type Props = {
  onClick?: () => void
  to?: string
  position?: keyof typeof styles.positions
  disabled?: boolean
  className?: string
}

export const ModalCloser = ({
  onClick,
  to,
  position = 'absolute',
  disabled,
  className,
}: Props) => {
  const theme = useTheme()
  const positionStyles = styles.positions[position]
  const closerStyles = [styles.root(theme), positionStyles]
  const isMobile = useIsMobile()

  return (
    <IconButton
      aria-label={/*i18n*/ i18n._('modal.close')}
      className={className}
      color="neutral"
      css={closerStyles}
      data-testid="modal-closer"
      disabled={disabled}
      icon={CloseIcon}
      size={isMobile ? 'small' : 'medium'}
      to={to}
      onClick={onClick}
    />
  )
}
